"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhotographerStencil = exports.photographerStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.photographerStencilDefinition = {
    view: {
        label: 'Photographer',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'subheading',
                    'title',
                    'bio',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'first-name',
                            'surname',
                            'location-of-nationality',
                            'participating-disciplines',
                            'participated-years',
                        ],
                    },
                    {
                        name: 'Social links',
                        items: ['social-links', 'website'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                ],
            },
        ],
        previewConfiguration: { hasPagePreview: true },
    },
    content: {
        [properties_1.bioPropertyDefinition.name]: properties_1.bioPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.firstNamePropertyDefinition.name]: properties_1.firstNamePropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.locationOfNationalityPropertyDefinition.name]: {
            ...properties_1.locationOfNationalityPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'stencils',
                    argument: ['country', 'worldwide-geolocation'],
                },
            ],
        },
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.participatedYearsPropertyDefinition.name]: properties_1.participatedYearsPropertyDefinition,
        [properties_1.participatingDisciplinesPropertyDefinition.name]: {
            ...properties_1.participatingDisciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
            ],
        },
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialLinksPropertyDefinition.name]: properties_1.socialLinksPropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.surnamePropertyDefinition.name]: properties_1.surnamePropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.websitePropertyDefinition.name]: properties_1.websitePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: ['illume'],
    name: 'photographer',
};
const isPhotographerStencil = (stencil) => {
    return stencil.name === exports.photographerStencilDefinition.name;
};
exports.isPhotographerStencil = isPhotographerStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhvdG9ncmFwaGVyLnN0ZW5jaWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RlbmNpbHMvcGhvdG9ncmFwaGVyLnN0ZW5jaWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsOENBMkJzQjtBQUVULFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsS0FBSyxFQUFFLGtCQUFrQjtRQUN6QixVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUM7UUFDckIsVUFBVSxFQUFFLENBQUMsZ0JBQWdCLENBQUM7UUFDOUIsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFO29CQUNMLGNBQWM7b0JBQ2QsWUFBWTtvQkFDWixPQUFPO29CQUNQLEtBQUs7aUJBQ047YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLFFBQVEsRUFBRTtvQkFDUjt3QkFDRSxJQUFJLEVBQUUsU0FBUzt3QkFDZixLQUFLLEVBQUU7NEJBQ0wsV0FBVzs0QkFDWCxjQUFjOzRCQUNkLGdCQUFnQjs0QkFDaEIsV0FBVzs0QkFDWCxLQUFLOzRCQUNMLGdCQUFnQjs0QkFDaEIsZ0JBQWdCO3lCQUNqQjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsWUFBWTt3QkFDbEIsS0FBSyxFQUFFOzRCQUNMLFlBQVk7NEJBQ1osU0FBUzs0QkFDVCx5QkFBeUI7NEJBQ3pCLDJCQUEyQjs0QkFDM0Isb0JBQW9CO3lCQUNyQjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsY0FBYzt3QkFDcEIsS0FBSyxFQUFFLENBQUMsY0FBYyxFQUFFLFNBQVMsQ0FBQztxQkFDbkM7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFVBQVU7d0JBQ2hCLEtBQUssRUFBRTs0QkFDTCxjQUFjOzRCQUNkLFlBQVk7NEJBQ1osaUJBQWlCO3lCQUNsQjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsbUJBQW1CO3dCQUN6QixLQUFLLEVBQUUsQ0FBQyxzQkFBc0IsQ0FBQztxQkFDaEM7aUJBQ0Y7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxTQUFTO2dCQUNmLEtBQUssRUFBRTtvQkFDTCxhQUFhO29CQUNiLG9CQUFvQjtvQkFDcEIsWUFBWTtvQkFDWixrQkFBa0I7aUJBQ25CO2FBQ0Y7U0FDRjtRQUNELG9CQUFvQixFQUFFLEVBQUUsY0FBYyxFQUFFLElBQUksRUFBRTtLQUMvQztJQUNELE9BQU8sRUFBRTtRQUNQLENBQUMsa0NBQXFCLENBQUMsSUFBSSxDQUFDLEVBQUUsa0NBQXFCO1FBQ25ELENBQUMsZ0RBQW1DLENBQUMsSUFBSSxDQUFDLEVBQUUsZ0RBQW1DO1FBQy9FLENBQUMsMENBQTZCLENBQUMsSUFBSSxDQUFDLEVBQUUsMENBQTZCO1FBQ25FLENBQUMsNENBQStCLENBQUMsSUFBSSxDQUFDLEVBQUUsNENBQStCO1FBQ3ZFLENBQUMsNENBQStCLENBQUMsSUFBSSxDQUFDLEVBQUUsNENBQStCO1FBQ3ZFLENBQUMsNENBQStCLENBQUMsSUFBSSxDQUFDLEVBQUUsNENBQStCO1FBQ3ZFLENBQUMsd0NBQTJCLENBQUMsSUFBSSxDQUFDLEVBQUUsd0NBQTJCO1FBQy9ELENBQUMsMENBQTZCLENBQUMsSUFBSSxDQUFDLEVBQUUsMENBQTZCO1FBQ25FLENBQUMsb0RBQXVDLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDOUMsR0FBRyxvREFBdUM7WUFDMUMsV0FBVyxFQUFFO2dCQUNYO29CQUNFLElBQUksRUFBRSxVQUFVO29CQUNoQixRQUFRLEVBQUUsS0FBSztpQkFDaEI7Z0JBQ0Q7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLFFBQVEsRUFBRSxDQUFDLFNBQVMsRUFBRSx1QkFBdUIsQ0FBQztpQkFDL0M7YUFDRjtTQUNGO1FBQ0QsQ0FBQyw2Q0FBZ0MsQ0FBQyxJQUFJLENBQUMsRUFBRSw2Q0FBZ0M7UUFDekUsQ0FBQyxnREFBbUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxnREFBbUM7UUFDL0UsQ0FBQyx1REFBMEMsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUNqRCxHQUFHLHVEQUEwQztZQUM3QyxXQUFXLEVBQUU7Z0JBQ1g7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLFFBQVEsRUFBRSxLQUFLO2lCQUNoQjthQUNGO1NBQ0Y7UUFDRCxDQUFDLGtEQUFxQyxDQUFDLElBQUksQ0FBQyxFQUFFLGtEQUFxQztRQUNuRixDQUFDLDBDQUE2QixDQUFDLElBQUksQ0FBQyxFQUFFLDBDQUE2QjtRQUNuRSxDQUFDLHVDQUEwQixDQUFDLElBQUksQ0FBQyxFQUFFLHVDQUEwQjtRQUM3RCxDQUFDLDBDQUE2QixDQUFDLElBQUksQ0FBQyxFQUFFLDBDQUE2QjtRQUNuRSxDQUFDLDBDQUE2QixDQUFDLElBQUksQ0FBQyxFQUFFLDBDQUE2QjtRQUNuRSxDQUFDLHlDQUE0QixDQUFDLElBQUksQ0FBQyxFQUFFO1lBQ25DLEdBQUcseUNBQTRCO1lBQy9CLE9BQU8sRUFBRSxJQUFJO1NBQ2Q7UUFDRCxDQUFDLHlDQUE0QixDQUFDLElBQUksQ0FBQyxFQUFFLHlDQUE0QjtRQUNqRSxDQUFDLHNDQUF5QixDQUFDLElBQUksQ0FBQyxFQUFFLHNDQUF5QjtRQUMzRCxDQUFDLDZDQUFnQyxDQUFDLElBQUksQ0FBQyxFQUFFLDZDQUFnQztRQUN6RSxDQUFDLHdDQUEyQixDQUFDLElBQUksQ0FBQyxFQUFFLHdDQUEyQjtRQUMvRCxDQUFDLG9DQUF1QixDQUFDLElBQUksQ0FBQyxFQUFFLG9DQUF1QjtRQUN2RCxDQUFDLHVDQUEwQixDQUFDLElBQUksQ0FBQyxFQUFFLHVDQUEwQjtRQUM3RCxDQUFDLGtDQUFxQixDQUFDLElBQUksQ0FBQyxFQUFFLGtDQUFxQjtRQUNuRCxDQUFDLHNDQUF5QixDQUFDLElBQUksQ0FBQyxFQUFFLHNDQUF5QjtLQUM1RDtJQUNELGFBQWEsRUFBRSxFQUFFO0lBQ2pCLEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFLENBQUMsUUFBUSxDQUFDO0lBQ2xCLElBQUksRUFBRSxjQUFjO0NBQ1UsQ0FBQTtBQUl6QixNQUFNLHFCQUFxQixHQUFHLENBQUMsT0FBb0IsRUFBa0MsRUFBRTtJQUM1RixPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQzVELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9